function getUrls(basepath) {
    let originPath = window.location.origin;
    if (!originPath.endsWith("/")) {
        originPath += "/";
    }
    if (basepath) {
        originPath += basepath + "/";
    }

    let baseUrl = originPath + "api/reportdata/";
    const urlGetSettings = baseUrl + "GetSettings";
    const urlGetIdentityServerHost = baseUrl + "IdentityServerHost";
    return { baseUrl, originPath, urlGetIdentityServerHost, urlGetSettings };
}
export default getUrls;
